import * as ActionTypes from "../actions/types";
import {
  mapDocumentationData,
  mapDocumentationDatum,
} from "../constants/map/documentation";

const INITIAL_STATE = {
  errorMessage: null,
  loading: false,
  byId: {},
};

function storeApiDocumentation(state, action) {
  const documentation = mapDocumentationDatum(action.payload);
  if (documentation && documentation.uuid) {
    state.loading = false;
    state.byId[documentation.uuid] = documentation;
  }
}

function fetchApiDocumentation(state) {
  state.loading = true;
  state.errorMessage = null;
}

function fetchApiDocumentationFailed(state) {
  state.errorMessage = "Swagger not found";
  state.loading = false;
  state.url = null;
}

function fetchApiProductSuccess(state, action) {
  const { included } = action.payload;
  if (included && Array.isArray(included)) {
    const apiEndpoints = included.filter(
      (i) => i.type === "node--api_endpoint"
    );
    const mappedDocs = mapDocumentationData(apiEndpoints);

    if (mappedDocs) {
      // Merge the new documentation data with existing
      state.byId = {
        ...state.byId,
        ...mappedDocs,
      };
    }
  }
}

export const apiDocumentation = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.STORE_API_DOCUMENTATION]: storeApiDocumentation,
    [ActionTypes.FETCH_API_DOCUMENTATION]: fetchApiDocumentation,
    [ActionTypes.FETCH_API_DOCUMENTATION_FAILED]: fetchApiDocumentationFailed,
    [ActionTypes.FETCH_API_PRODUCT_SUCCESS]: fetchApiProductSuccess,
  },
};
